import React from 'react'

const Heading = ({ title, children, description }) => {
  return (
    <div className='px-5 mt-5 heading-container md:px-10'>
    <div className="max-container">
    <div className="info">
      <h3 className='lg:text-5xl md:text-4xl small:text-3xl text-[18px] text-primary font-bold '>{title} Airport Parking</h3>
      <p className='lg:text-[18px] text-[16px] text-black small:mt-4 mt-2 font-medium'>{description}</p>
    </div>
    <div className="transparent-icon">{children}</div>
  </div>
  </div>
  )
}

export default Heading